import type { IconGlyph } from '@sunwebgroup/uds-ui/icon'
import { SidebarItem } from './SidebarItem'

interface ExtrasSidebarItemProps {
  label: string
  iconName: IconGlyph
  children: React.ReactNode
}

export function ExtrasSidebarItem({ label, iconName, children }: ExtrasSidebarItemProps) {
  return (
    <SidebarItem iconName={iconName} label={label}>
      {children}
    </SidebarItem>
  )
}
